module.exports = __webpack_public_path__ + "static/media/infodesktop.2d80fb3d.jpg";